export const news = {
  newsFeedCreateInputPlaceholder: '게시물 작성...',
  newsFeedSearchInputPlaceholder: '검색',
  newsFeedPostOwnerCurtainEditTitle: '게시물 편집',
  newsFeedPostOwnerCurtainDeleteTitle: '게시물 삭제',
  newsFeedEditedPostSavedAlertText: '게시물이 저장되었습니다!',
  newsFeedEditedPostDeletedAlertText: '게시물이 삭제되었습니다!',
  newsFeedShareCurtainOptionTitle: '링크 복사',
  newsFeedPostLinkCopiedAlertText: '링크가 복사되었습니다!',
  newsFeedOthersPostCurtainOptionCopyTitle: '링크 복사',
  newsFeedOthersPosLinkCopiedAlertText: '링크가 복사되었습니다!',
  newsFeedOthersPostCurtainOptionFlagTitle: '콘텐츠 신고',
  newsFeedOtherPostOwnersCurtainDeleteTitle: '게시물 삭제',
  newsFeedPostDeletePopupTitle: '삭제',
  newsFeedPostDeletePopupText: '이 게시물을 삭제하시겠습니까?',
  newsFeedPostDeletePopupCancelButtonTitle: '취소',
  newsFeedPostDeletePopupConfirmButtonTitle: '확인',
  newsFeedPostDeeletedAlertText: '게시물이 삭제되었습니다!',
  newsPostDetailsHeaderTitle: '게시물',
  postFeedPostLikesText: '좋아요',
  postFeedPostCommentsText: '댓글',
  postFeedPostNoLikesText: '아직 좋아요가 없습니다',
  postFeedPostLeaveFirstLikeText: '첫 번째 좋아요를 남겨보세요',
  newsFeedPostDetailsNoCommentsText: '아직 댓글이 없습니다',
  newsFeedPostDetailsFirstCommentText: '첫 번째 댓글을 남겨보세요',
  newsFeedPostDetailsShareOptionTitle: '링크 복사',
  newsFeedPostDetailsSharePostCopiedAlertText: '링크가 복사되었습니다!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: '링크 복사',
  newsFeedPostDetailsCopiedAlertText: '링크가 복사되었습니다!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: '콘텐츠 신고',
  newsPostDetailsFlagCurtainOptionSpamTitle: '신고',
  newsPostDetailsReportedCurtainText: '콘텐츠가 신고되었습니다',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: '댓글 편집',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: '댓글 삭제',
  newsPostDetailsEditedCommentSavedAlertText: '댓글이 저장되었습니다!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: '댓글 삭제',
  postDetailsOtherUsersCommentDeletadAlertText: '댓글이 삭제되었습니다!',
  postDetailsDeleteCommentPopupTitle: '삭제',
  postDetailsDeleteCommentPopupText: '이 댓글을 삭제하시겠습니까?',
  postDetailsDeleteCommentPopupCancelButtonTitle: '취소',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: '확인',
  postDetailsCommDeletedAlertText: '댓글이 삭제되었습니다!',
  postDetailsCommentUserCurtainOptionTitle: '콘텐츠 신고',
  newsCreatePostCurtainTitle: '새 게시물',
  newsCreatePostCurtainBodyPlaceholder: '여기에 텍스트를 입력하세요...',
  newsCreatePostPublishButtonTitle: '게시',
  newsCreatePostUploadSlallerImageAlertText: '한 번에 최대 {size} MB만 업로드할 수 있습니다',
  newsPostSavedAlertText: '게시물이 저장되었습니다!',
  newsCreatePostAddLocationCurtainTitle: '장소',
  newsCreatePostAddLocationCurtainInputPlaceholder: '장소 이름',
  newsCreatePostEditLocationCurtainText: '장소 편집',
  newsDeleteLocation: '장소 삭제',
  newsDiscardPostPopupTitle: '드래프트',
  newsDiscardPostPopupText: '이 드래프트를 삭제하시겠습니까?',
  newsDiscardPostPopupCancelButtonTitle: '취소',
  newsDiscardPostPopupCofirmButtonTitle: '확인',
  newsNewPostCreatePollTitle: '투표 만들기',
  newsNewPostCreatePollTitleInputPlaceholder: '제목',
  newsNewPostCreatePollOptionInputPlaceholder: '옵션',
  newsNewPostCreatePollAddButtonTitle: '옵션 추가',
  newsNewPostCreatePollCreateButtonTitle: '만들기',
  newsCreatePostPollTitleBlankAlertText: '제목은 비워둘 수 없습니다!',
  newsCreatePostPollOptionBlankAlertText: '옵션은 비워둘 수 없습니다!',
  newsCreatePostPollLongTitleAlertText: '제목은 최대 {length}자여야 합니다',
  newsCreatePostPollLongOptionAlertText: '옵션은 최대 {length}자여야 합니다',
  newsCreatePostPollEditOptionTitle: '투표 편집',
  newsCreatePostPollRemoveOptionTitle: '투표 제거',
  newsPostPollInfoVotesText: '투표',
  newsPostPollInfoEditVoteText: '투표 편집',
  newsPostPollFinishPollText: '투표 종료',
  newsPostPollFinishedPollText: '종료됨',
  newsPostPollInProgresslText: '진행 중',
  newsFinishPollCurtainTitle: '투표 종료',
  newsFinishPollCurtainText: '투표 종료 후에는 사용자가 투표할 수 없습니다.',
  newsFinishPollCurtainCancelButtonTitle: '취소',
  newsFinishPollCurtainConfirmlButtonTitle: '확인',
  newsPollInfoPollVotesCurtainTitle: '투표 결과',
  newsEditPostCurtainTitle: '게시물 편집',
  newsEditPostCurtainNoTextBodyPlaceholder: '여기에 텍스트를 입력하세요...',
  newsEditPostCurtainSaveButtonTitle: '저장',
  newsEditPostSavedAlertText: '게시물이 저장되었습니다!',
  newsError: '문제가 발생했습니다!',
  newsAt: '에서',
  newsSeeMore: '더 보기...',
  newsMaxAttachments: '첨부 파일은 최대 {length}개까지 가능합니다',
  newsReply: '댓글',
  newsPin: '게시물 고정',
  newsUnpin: '고정 해제'
}
